)<template>
  <v-layout row justify-center>
    <v-btn color="primary hide" id="searchTuneModalBtn" dark @click.stop="dialog = !dialog">曲検索</v-btn>
    <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay=false
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-btn icon @click.native="closeModal()" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>曲検索</v-toolbar-title>
        </v-toolbar>

        <v-card-text style="max-width:700px; margin:0 auto 80px;">
          <div class="table__overflow elevation-1">
            <table class="datatable table">
              <tbody>
              <tr>
                <td class="subheading">追加先プレイリスト</td>
                <td class="text-xs-left" v-if="$store.state.searchTuneModal.playListType === 1">進行プレイリスト</td>
                <td class="text-xs-left" v-if="$store.state.searchTuneModal.playListType === 2">歓談プレイリスト</td>
              </tr>
              <tr v-if="sceneAvatarPath">
                <td class="subheading">追加先シーン</td>
                <td class="text-xs-left">
                  <v-avatar size="43px">
                  <img :src="[sceneAvatarPath]" class="list-avatar">
                  </v-avatar>
                  {{sceneName}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <h2 class="title primary--text my-3">検索条件</h2>
          <v-select
            v-model="selectedScenes"
            :items="$store.state.searchTuneOption.scenes"
            item-text="sceneName"
            item-value="id"
            label="シーンを選択"
            chips
            multiple
            clearable
          >
          </v-select>

          <v-select
            v-model="selectedTags"
            :items="$store.state.searchTuneOption.tags"
            item-text="tagName"
            item-value="id"
            label="タグを選択"
            chips
            clearable
            multiple
          >
          </v-select>

          <v-text-field
            v-model="freeWords"
            label="フリーワード"
            single-line
            clearable
          ></v-text-field>
          <v-checkbox
            v-model="checkPlaylist"
            label="プレイリストに登録済みのものは表示しない">
          </v-checkbox>

          <v-btn color="blue darken-1" dark @click="searchTrue()">検索</v-btn>
          <v-divider class="my-4"></v-divider>
          <h2 class="title primary--text my-3">検索結果{{searchResultCount}}</h2>
          <v-list two-line :class=shufflePlay>
            <v-list-tile v-for="(item, index) in this.$store.state.searchResult" :key="item.product_id" avatar class="itemDivider" :class="nowPlayingIndex" >
              <v-list-tile-avatar>
                <play-btn
                :itemTitle="item.name"
                :itemArtist="item.artist_name"
                :itemSrc="item.mp3"
                :itemIndex=parseInt(index)
                :itemProductId="item.product_id"
                :musicPlayerType=musicPlayerType
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                <router-link :to="'/home/artist/detail/' + item.artist_id">
                  <v-list-tile-sub-title>{{ item.artist_name }}</v-list-tile-sub-title>
                </router-link>
              </v-list-tile-content>
              <v-spacer></v-spacer>
              <DuplicationAlertButton v-if="isNotExistDuplicationTune(item.product_id)"/>
              <lyrics
              :title="item.name"
              :artist="item.artist_name"
              :lyrics="item.lyrics"
              :introduction="item.introduction"/>
              <v-btn flat icon color="green" @click="decideTune(item.product_id)">
                <v-icon>add_circle_outline</v-icon>
              </v-btn>
            </v-list-tile>
            <infinite-loading v-if="searched" @infinite="infiniteHandler" ref="infiniteLoading"></infinite-loading>
          </v-list>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <AlertCoverNotLandScape/>
  </v-layout>
</template>
<script>
import PlayListService from '@/components/services/PlayListService.vue'
import TagService from '@/components/services/TagService.vue'
import SceneService from '@/components/services/SceneService.vue'
import CustomerPlayListService from '@/components/services/CustomerPlayListService.vue'
import Lyrics from '@/components/Lyrics.vue'
import PlayBtn from '@/components/PlayBtn.vue'
import DuplicationAlertButton from '@/components/Modules/DuplicationAlertButton'
import InfiniteLoading from 'vue-infinite-loading'
import AlertCoverNotLandScape from '@/components/atoms/AlertCoverNotLandScape'
export default {
  data () {
    return {
      selectedScenes: null,
      selectedTags: null,
      dialog: false,
      items: [],
      searched: false,
      freeWords: undefined,
      checkPlaylist: true,
      searchResultCount: null,
      musicPlayerType: 'search'
    }
  },
  components: {
    InfiniteLoading,
    AlertCoverNotLandScape,
    DuplicationAlertButton,
    Lyrics,
    PlayBtn
  },
  created () {
    // 初期化
    this.$store.dispatch('resetMusicData')

    if (this.$store.getters.getSearchTuneModalCanSearchSceneId) {
      this.selectedScenes = [this.$store.getters.getSearchTuneModalCanSearchSceneId]
    } else {
      this.selectedScenes = null
    }
  },
  mounted () {
    this.clickBtn()
  },
  computed: {
    sceneAvatarPath () {
      return SceneService.findIconPathBySceneId(this.$store.state.searchTuneModal.sceneId)
    },
    sceneName () {
      return SceneService.findSceneNameBySceneId(this.$store.state.searchTuneModal.sceneId)
    },
    nowPlayingIndex () {
      let nowIndex = Number(this.$store.getters['musicPlayerModuleGetNowPlayTuneData'].index)
      let resultCount = Number(this.$store.state.searchResultCount)
      let itemCount = Number(this.$store.state.searchResult.length)
      if ((resultCount > itemCount + 1)) {
        if ((nowIndex > (itemCount - 2)) && !this.$store.getters['getSearchInfiniteLoadingFlg']) {
          // 1曲前を超えたら次のリストの読み込みイベントを自動発火
          this.infiniteHandler()
        }
      }
      return nowIndex
    },
    shufflePlay () {
      let isShufflePlay = this.$store.getters.musicPlayerModuleGetIsShufflePlay
      this.changeShufflePlay(isShufflePlay)
      return isShufflePlay
    }
  },
  methods: {
    clickBtn () {
      document.getElementsByTagName('footer')[0].style.zIndex = 230
      document.getElementById('searchTuneModalBtn').click()
    },
    closeModal () {
      this.clickBtn()
      let that = this
      setTimeout(() => {
        this.$store.commit('searchInfiniteLoadingFlg', false)
        that.$store.dispatch('closeSearchTuneModal')
        document.getElementsByTagName('footer')[0].style.zIndex = 199
      }, 300)
    },
    /**
     * 曲検索
     **/
    searchTrue () {
      let sceneIdArray = []
      let tagIdArray = []
      let formData = new URLSearchParams()
      // シーンをパラメータに
      if (this.selectedScenes) {
        for (let scene in this.selectedScenes) {
          let scenesId = this.selectedScenes[scene]
          formData.append('scene[]', scenesId)
          sceneIdArray.push(scenesId)
        }
      }
      // タグをパラメータに
      for (let tag in this.selectedTags) {
        let tagId = this.selectedTags[tag]
        formData.append('tag[]', tagId)
        tagIdArray.push(tagId)
      }
      // フリーワードをパラメータに
      if (this.freeWords !== undefined) {
        let freewordArray = []
        freewordArray = this.freeWords.replace(/\s+/g, ' ').split(' ')
        for (let i in freewordArray) {
          let word = freewordArray[i]
          formData.append('freeword[]', word)
        }
      }

      // プレイリスト・チェックボックス
      formData.append('playlist', this.checkPlaylist)

      formData.append('offset', 0)
      // FIXME 初期検索結果件数を変更してください
      formData.append('limit', this.$store.state.perSearchCount)
      formData.append('transactionid', this.$store.state.transactionId)
      PlayListService.searchTrue(formData, (response) => {
        this.item = response
        this.$store.commit('updateSearchResult', response)
        this.$store.commit('updateStateSelectedScenes', this.selectedScenes)
        this.$store.commit('updateStateSelectedTags', this.selectedTags)
        this.$store.commit('updateStateSelectedSceneIdArray', sceneIdArray)
        this.$store.commit('updateStateSelectedTagIdArray', tagIdArray)
        this.$store.commit('updateStateFreeWords', this.freeWords)
        this.$store.commit('updateStateCheckPlaylistFlg', this.checkPlaylist)
        this.$store.commit('updateStateSearchOffset', 0)
        // 検索結果件数を表示
        this.searchResultCount = '：' + this.$store.state.searchResultCount + '曲HITしました'
        this.searched = true
      }, (error) => {
        this.$log.error(error)
      })
    },
    decideTune (productId) {
      this.$log.debug('decideTune START productId:' + productId, 'customerPlayListId' + this.$store.state.searchTuneModal.customerPlayListId)
      let formData = new URLSearchParams()
      formData.append('product_id', productId)
      formData.append('customer_playlist_product_id', this.$store.state.searchTuneModal.customerPlayListId)
      formData.append('transactionid', this.$store.state.transactionId)
      CustomerPlayListService.updatePlayListTune(formData, (response) => {
        CustomerPlayListService.findCustomerPlayList(this.$store.state.searchTuneModal.playListType, this.$store.state.transactionId, (response) => {
          this.$log.debug('decideTune', 'findCustomerPlayList', response)
          this.closeModal()
        }, (error) => {
          this.$log.error(error)
        })
      }, (error) => {
        this.$log.error(error)
      })
      this.$log.debug('decideTune END')
    },
    infiniteHandler ($state = { loaded () {}, complete () {} }) {
      this.$log.debug('inifiteHandler START')
      this.$store.commit('searchInfiniteLoadingFlg', true)
      // TODO 共通関数を作成する
      setTimeout(() => {
        let offset = this.$store.state.searchOffset + this.$store.state.perSearchCount
        let formData = new URLSearchParams()
        // シーンをパラメータに
        for (let scene in this.$store.state.selectedsceneIdArray) {
          formData.append('scene[]', this.$store.state.selectedsceneIdArray[scene])
        }
        // タグをパラメータに
        for (let tag in this.$store.state.selectedTagIdArray) {
          formData.append('tag[]', this.$store.state.selectedTagIdArray[tag])
        }
        // フリーワードをパラメータに
        if (this.$store.state.freeWords !== undefined) {
          let freewordArray = []
          freewordArray = this.$store.state.freeWords.replace(/\s+/g, ' ').split(' ')
          for (let i in freewordArray) {
            let word = freewordArray[i]
            formData.append('freeword[]', word)
          }
        }
        // プレイリスト・チェックボックス
        formData.append('playlist', this.$store.state.checkPlaylistFlg)

        formData.append('offset', offset)
        // FIXME 検索結果件数を変更してください
        formData.append('limit', this.$store.state.perSearchCount)
        formData.append('transactionid', this.$store.state.transactionId)
        PlayListService.searchTrue(formData, (response) => {
          var responseCount = (Object.keys(response).length)
          if (responseCount > 0) {
            var newItems = []
            for (var index in this.$store.state.searchResult) {
              newItems.push(this.$store.state.searchResult[index])
            }
            for (var index2 in response) {
              newItems.push(response[index2])
            }
            this.items = newItems
            this.$store.state.searchResult = newItems
            this.$store.commit('updateStateSearchOffset', offset)

            if (this.$store.getters['musicPlayerModuleGetNowPlayListType'] === 'search' || this.$store.getters['musicPlayerModuleGetNowPlayListType'] === 'searchShufflePlay') {
              // 検索結果を再設定（再生範囲修正のために追加）* Search.vueにも同様の記述追加
              // this.$store.commit('musicPlayerModuleSetPlayList', 'search')

              // シャッフルプレイを再設定（再生範囲修正のために追加）* Search.vueにも同様の記述追加
              this.$store.commit('musicPlayerModuleStartPlayList', [this.nowPlayingIndex, 'search'])

              // let shufflePlayListTmp = this.$store.getters.musicPlayerModuleGetNowSelectedPlayList.slice(0, offset)
              let shufflePlayListTmp = this.$store.getters.musicPlayerModuleGetShufflePlayList
              let shufflePlayList = this.$store.getters.musicPlayerModuleGetNowSelectedPlayList.slice(offset)
              // offsetまで連番でセットして、offset以降をランダム再生
              let target = shufflePlayList.map(record => { return record })
              let a = target.length
              while (a) {
                let j = Math.floor(Math.random() * a)
                let t = target[--a]
                target[a] = target[j]
                target[j] = t
              }
              target = shufflePlayListTmp.concat(target)
              this.$store.commit('musicPlayerModuleUpdateShufflePlayList', target)
              this.$store.commit('musicPlayerModuleShuffle', this.$store.getters.musicPlayerModuleGetIsShufflePlay)

              if (this.$store.getters.musicPlayerModuleGetIsShufflePlay) {
                this.$store.commit('musicPlayerModuleStartPlayList', [this.nowPlayingIndex, 'searchShufflePlay'])
              }
            }

            $state.loaded()
          } else {
            $state.complete()
          }
          this.$log.debug('inifiteHandler END')
          this.$store.commit('searchInfiniteLoadingFlg', false)
        })
      }, 1000)
    },
    showSearchConditionScene (sceneIdArray) {
      let index = 0
      let sceneNames = ''
      if (sceneIdArray.length > 0) {
        sceneIdArray.forEach(id => {
          if (index === 0) {
            sceneNames = SceneService.findSceneNameBySceneId(id)
          } else {
            sceneNames += '、' + SceneService.findSceneNameBySceneId(id)
          }
          index++
        })
      } else {
        sceneNames = '-'
      }
      return sceneNames
    },
    showSearchConditionTag (TagIdArray) {
      let index = 0
      let tagNames = ''
      if (TagIdArray.length > 0) {
        TagIdArray.forEach(id => {
          if (index === 0) {
            tagNames = TagService.findTagNameByTagId(id)
          } else {
            tagNames += '、' + TagService.findTagNameByTagId(id)
          }
          index++
        })
      } else {
        tagNames = '-'
      }
      return tagNames
    },
    /**
     * productIdを指定してプレイリストに同じ楽曲が無いかを判断し、存在する場合注意文を返すメソッド
     * @param productId
     * @return {string}
     */
    isNotExistDuplicationTune (productId) {
      if (CustomerPlayListService.isNotExistDuplicationTune(productId, this.$store.state.searchTuneModal.playListType, this.$store.state.searchTuneModal.playListIndex) === false) {
        return true
      } else {
        return false
      }
    },
    changeShufflePlay (isShufflePlay) {
      if (this.$store.getters.musicPlayerModuleGetIsPlaying === false) {
        if (isShufflePlay === true) {
          this.musicPlayerType = 'searchShufflePlay'
        } else {
          this.musicPlayerType = 'search'
        }
        this.$store.commit('musicPlayerModuleSetPlayList', this.musicPlayerType)
      } else {
        this.musicPlayerType = 'search'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.warn-text {
   text-align: right;
   color: #ff8f00!important;
 }
.add-destination__row {
  min-height: 40px;
  vertical-align: middle;
  margin: auto;
}
.add-destination__th {
  font-weight: bold;
}
.input-group label {
  overflow: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/SearchTuneModal.vue